<h3>{{ "forms.educationalResource.preview.title" | translate }}</h3>

<dl class="row g-0">
  @if (hasName) {
    @if (savedData?.name?.fi) {
      <div appPreviewRow
        [title]="'forms.educationalResource.files.materialName.label.fi' | translate"
      [item]="savedData.name.fi"></div>
    }
    @if (savedData?.name?.en) {
      <div appPreviewRow
        [title]="'forms.educationalResource.files.materialName.label.en' | translate"
      [item]="savedData.name.en"></div>
    }
    @if (savedData?.name?.sv) {
      <div appPreviewRow
        [title]="'forms.educationalResource.files.materialName.label.sv' | translate"
      [item]="savedData.name.sv"></div>
    }
  } @else {
    <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.name" | translate }}</dt>
    <dd class="col-sm-9">
      <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
      <a [routerLink]="['/lisaa-oppimateriaali', 1]">
        {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
      </a>
    </dd>
  }

</dl>

<hr />

<h3>{{ "forms.educationalResource.nav.files" | translate }}</h3>

@if (hasMaterial) {
  <p>{{ "forms.educationalResource.preview.material-help" | translate }}</p>
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th scope="col">#</th>
        <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.fileOrLink" | translate }}</th>
        <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.displayName" | translate }}</th>
        <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.language" | translate }}</th>
        <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.subtitles" | translate }}</th>
      </tr>
    </thead>
    <tbody cdkDropList (cdkDropListDropped)="drop($event)">
      @for (upload of (uploadedFiles$ | async); track upload; let i = $index) {
        <tr cdkDrag>
          <td><i class="fa fa-bars" aria-hidden="true"></i></td>
          <th scope="row">{{ i + 1 }}</th>
          <td>{{ upload.file }}{{ upload.link }}</td>
          <td>
            <ul class="list-unstyled">
              @if (upload.displayName.fi) {
                <li>
                  <strong>fi:</strong>
                  {{ upload.displayName.fi }}
                </li>
              }
              @if (upload.displayName.sv) {
                <li>
                  <strong>sv:</strong>
                  {{ upload.displayName.sv }}
                </li>
              }
              @if (upload.displayName.en) {
                <li>
                  <strong>en:</strong>
                  {{ upload.displayName.en }}
                </li>
              }
            </ul>
          </td>
          <td>{{ upload.language }}</td>
          <td>
            @for (subtitle of upload.subtitles; track subtitle; let isLast = $last) {
              <span
                [class.fw-bold]="subtitle.default">
                {{ subtitle.label }} ({{ subtitle.srclang }})
                @if (!isLast) {
                  <br />
                }
              </span>
            }
            @if (upload.subtitles.length === 0) {
              <span>-</span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
} @else {
  <dl class="row g-0">
    <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.material" | translate }}</dt>
    <dd class="col-sm-9">
      <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
      <a [routerLink]="['/lisaa-oppimateriaali', 1]">{{ "forms.educationalResource.files.file.error" | translate }}</a>
    </dd>
  </dl>
}


<h3>{{ "forms.educationalResource.nav.basicDetails" | translate }}</h3>

<dl class="row g-0">
  @if (hasAuthor) {
    @for (author of savedData.authors; track author) {
      <dt class="col-sm-3">{{ "forms.educationalResource.basicDetails.author.inputs.author.label" | translate }}</dt>
      <dd class="col-sm-9">
        @if (author.author) {
          {{ author.author }}
          @if (author.organization) {
            , {{ author.organization.value }}
          }
        }
        @if (!author.author) {
          {{ author.organization.value }}
        }
      </dd>
    }
  } @else {
    <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.author" | translate }}</dt>
    <dd class="col-sm-9">
      <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
      <a [routerLink]="['/lisaa-oppimateriaali', 2]">
        {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
      </a>
    </dd>
  }


  @if (hasKeyword) {
    <div appPreviewRow
      [title]="'forms.educationalResource.basicDetails.keywords.label' | translate"
      [items]="savedData?.keywords"
    property="value"></div>
  } @else {
    <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.keywords" | translate }}</dt>
    <dd class="col-sm-9">
      <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
      <a [routerLink]="['/lisaa-oppimateriaali', 2]">
        {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
      </a>
    </dd>
  }


  @if (hasLearningResourceType) {
    <div appPreviewRow
      [title]="'forms.educationalResource.basicDetails.learningResourceTypes.label' | translate"
      [items]="savedData?.learningResourceTypes"
    property="value"></div>
  } @else {
    <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.learningResourceTypes" | translate }}</dt>
    <dd class="col-sm-9">
      <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
      <a [routerLink]="['/lisaa-oppimateriaali', 2]">
        {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
      </a>
    </dd>
  }


  @if (savedData?.educationalRoles?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.basicDetails.educationalRoles.label' | translate"
      [items]="savedData.educationalRoles"
    property="value"></div>
  }

  @if (savedData?.educationalUses?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.basicDetails.educationalUses.label' | translate"
      [items]="savedData.educationalUses"
    property="value"></div>
  }

  @if (savedData?.description) {
    @if (savedData?.description?.fi) {
      <div appPreviewRow
        [title]="'forms.educationalResource.basicDetails.description.label.fi' | translate"
      [item]="savedData.description.fi"></div>
    }
    @if (savedData?.description?.en) {
      <div appPreviewRow
        [title]="'forms.educationalResource.basicDetails.description.label.en' | translate"
      [item]="savedData.description.en"></div>
    }
    @if (savedData?.description?.sv) {
      <div appPreviewRow
        [title]="'forms.educationalResource.basicDetails.description.label.sv' | translate"
      [item]="savedData.description.sv"></div>
    }
  }
</dl>

<hr />

<h3>{{ "forms.educationalResource.nav.educationalDetails" | translate }}</h3>

<dl class="row g-0">
  <div appPreviewRow
    [title]="'forms.educationalResource.educationalDetails.educationalLevels.label' | translate"
    [items]="savedData?.educationalLevels"
    property="value"
    [required]="!hasEducationalLevel"
  [routerLinkOptions]="['/lisaa-oppimateriaali', 3]"></div>

  <!-- early childhood education -->

  @if (earlyChildhoodEducationSubjects?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.subjects.label' | translate"
      [items]="earlyChildhoodEducationSubjects"
    property="targetName"></div>
  }

  @if (earlyChildhoodEducationObjectives?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.objectives.label' | translate"
      [items]="earlyChildhoodEducationObjectives"
    property="targetName"></div>
  }

  @if (savedData?.suitsAllEarlyChildhoodSubjects) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.earlyChildhoodEducation.title' | translate"
    [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
  }

  @if (earlyChildhoodEducationFramework?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.framework.label' | translate"
    [items]="earlyChildhoodEducationFramework"></div>
  }

  <!-- pre-primary education -->

  @if (prePrimaryEducationSubjects?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.subjects.label' | translate"
      [items]="prePrimaryEducationSubjects"
    property="targetName"></div>
  }

  @if (prePrimaryEducationObjectives?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.objectives.label' | translate"
      [items]="prePrimaryEducationObjectives"
    property="targetName"></div>
  }

  @if (savedData?.suitsAllPrePrimarySubjects) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.prePrimaryEducation.title' | translate"
    [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
  }

  @if (prePrimaryEducationFramework?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.framework.label' | translate"
    [items]="prePrimaryEducationFramework"></div>
  }

  <!-- basic education -->

  @if (basicStudySubjects?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.basicEducation.inputs.subjects.label' | translate"
      [items]="basicStudySubjects"
    property="targetName"></div>
  }

  @if (shouldHaveBasicEduObjectivesAndContents || hasBasicEduObjectives) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.basicEducation.inputs.objectives.label' | translate"
      [items]="basicStudyObjectives"
      property="targetName"
      [required]="shouldHaveBasicEduObjectivesAndContents && !hasBasicEduObjectives"
    [routerLinkOptions]="['/lisaa-oppimateriaali', 3]"></div>
  }

  @if (shouldHaveBasicEduObjectivesAndContents || hasBasicEduContents) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.basicEducation.inputs.contents.label' | translate"
      [items]="basicStudyContents"
      property="targetName"
      [required]="shouldHaveBasicEduObjectivesAndContents && !hasBasicEduContents"
    [routerLinkOptions]="['/lisaa-oppimateriaali', 3]"></div>
  }

  @if (savedData?.suitsAllBasicStudySubjects) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.basicEducation.title' | translate"
    [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
  }

  @if (basicStudyFramework?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.basicEducation.inputs.framework.label' | translate"
    [items]="basicStudyFramework"></div>
  }

  <!-- preparatory education -->

  @if (preparatoryEducationSubjects?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.preparatoryEducation.inputs.subjects.label' | translate"
      [items]="preparatoryEducationSubjects"
    property="targetName"></div>
  }

  @if (preparatoryEducationObjectives?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.preparatoryEducation.inputs.objectives.label' | translate"
      [items]="preparatoryEducationObjectives"
    property="targetName"></div>
  }

  <!-- upper secondary education -->

  @if (upperSecondarySchoolSubjectsOld?.length > 0) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.subjects.label' | translate
    "
      [items]="upperSecondarySchoolSubjectsOld"
    property="targetName"></div>
  }
  <!--upperSecondarySchoolSubjectsOld-->

  @if (upperSecondarySchoolCoursesOld?.length > 0) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.subjects.label' | translate
    "
      [items]="upperSecondarySchoolCoursesOld"
    property="targetName"></div>
  }
  <!--upperSecondarySchoolCoursesOld-->

  @if (upperSecondarySchoolObjectives?.length > 0) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.objectives.label' | translate
    "
      [items]="upperSecondarySchoolObjectives"
    property="targetName"></div>
  }

  @if (savedData?.suitsAllUpperSecondarySubjects) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.title' | translate"
    [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
  }

  @if (upperSecondarySchoolFramework?.length > 0) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.framework.label' | translate
    "
    [items]="upperSecondarySchoolFramework"></div>
  }

  <!-- upper secondary education (LOPS2019) -->

  @if (upperSecondarySchoolSubjectsNew?.length > 0) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.subjects.label' | translate
    "
      [items]="upperSecondarySchoolSubjectsNew"
    property="targetName"></div>
  }

  @if (shouldHaveUppSecondaryEduObjectivesAndContents || hasUpperSecondaryEduModules) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.modules.label' | translate
    "
      [items]="upperSecondarySchoolModulesNew"
      property="targetName"
      [required]="shouldHaveUppSecondaryEduObjectivesAndContents && !hasUpperSecondaryEduModules"
    [routerLinkOptions]="['/lisaa-oppimateriaali', 3]"></div>
  }

  @if (shouldHaveUppSecondaryEduObjectivesAndContents || hasUpperSecondaryEduObjectives) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.objectives.label'
        | translate
    "
      [items]="upperSecondarySchoolObjectivesNew"
      property="targetName"
      [required]="shouldHaveUppSecondaryEduObjectivesAndContents && !hasUpperSecondaryEduObjectives"
    [routerLinkOptions]="['/lisaa-oppimateriaali', 3]"></div>
  }

  @if (shouldHaveUppSecondaryEduObjectivesAndContents || hasUpperSecondaryEduContents) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.contents.label' | translate
    "
      [items]="upperSecondarySchoolContentsNew"
      property="targetName"
      [required]="shouldHaveUppSecondaryEduObjectivesAndContents && !hasUpperSecondaryEduContents"
    [routerLinkOptions]="['/lisaa-oppimateriaali', 3]"></div>
  }

  @if (newUpperSecondarySchoolFramework?.length > 0) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.framework.label' | translate
    "
    [items]="newUpperSecondarySchoolFramework"></div>
  }

  <!-- vocational education -->

  @if (vocationalDegrees?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.degrees.label' | translate"
      [items]="vocationalDegrees"
    property="targetName"></div>
  }

  @if (furtherVocationalQualifications?.length > 0) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.vocationalEducation.inputs.furtherVocationalQualifications.label'
        | translate
    "
      [items]="furtherVocationalQualifications"
    property="targetName"></div>
  }

  @if (specialistVocationalQualifications?.length > 0) {
    <div appPreviewRow
    [title]="
      'forms.educationalResource.educationalDetails.vocationalEducation.inputs.specialistVocationalQualifications.label'
        | translate
    "
      [items]="specialistVocationalQualifications"
    property="targetName"></div>
  }

  @if (vocationalCommonUnits?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.commonUnits.label' | translate"
      [items]="vocationalCommonUnits"
    property="targetName"></div>
  }

  @if (vocationalUnits?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.units.label' | translate"
      [items]="vocationalUnits"
    property="targetName"></div>
  }

  @if (vocationalRequirements?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.objectives.label' | translate"
      [items]="vocationalRequirements"
    property="targetName"></div>
  }
  <!--vocationalRequirements-->

  @if (savedData?.suitsAllVocationalDegrees) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.vocationalEducation.title' | translate"
    [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
  }

  @if (vocationalFramework?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.framework.label' | translate"
    [items]="vocationalFramework"></div>
  }

  <!-- self-motivated education -->

  @if (selfMotivatedEducationSubjects?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.selfMotivatedEducation.inputs.subjects.label' | translate"
      [items]="selfMotivatedEducationSubjects"
    property="targetName"></div>
  }

  @if (selfMotivatedEducationObjectives?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.selfMotivatedEducation.inputs.objectives.label' | translate"
      [items]="selfMotivatedEducationObjectives"
    property="targetName"></div>
  }

  @if (savedData?.suitsAllSelfMotivatedSubjects) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.selfMotivatedEducation.title' | translate"
    [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
  }

  <!-- higher education-->

  @if (branchesOfScience?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.higherEducation.inputs.branchesOfScience.label' | translate"
      [items]="branchesOfScience"
    property="targetName"></div>
  }

  @if (scienceBranchObjectives?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.higherEducation.inputs.objectives.label' | translate"
      [items]="scienceBranchObjectives"
    property="targetName"></div>
  }

  @if (savedData?.suitsAllBranches) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.higherEducation.title' | translate"
    [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
  }

  @if (higherEducationFramework?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.educationalDetails.higherEducation.inputs.framework.label' | translate"
    [items]="higherEducationFramework"></div>
  }
</dl>

<hr />

<h3>{{ "forms.educationalResource.nav.extendedDetails" | translate }}</h3>

<dl class="row g-0">
  @if (savedData?.accessibilityFeatures?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.extendedDetails.accessibility.inputs.features.label' | translate"
      [items]="savedData.accessibilityFeatures"
    property="value"></div>
  }

  @if (savedData?.accessibilityHazards?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.extendedDetails.accessibility.inputs.hazards.label' | translate"
      [items]="savedData.accessibilityHazards"
    property="value"></div>
  }

  @if (typicalAgeRange) {
    <div appPreviewRow
      [title]="'forms.educationalResource.extendedDetails.typicalAgeRange.label' | translate"
    [item]="typicalAgeRange"></div>
  }

  @if (savedData?.timeRequired) {
    <div appPreviewRow
      [title]="'forms.educationalResource.extendedDetails.timeRequired.label' | translate"
    [item]="savedData.timeRequired"></div>
  }

  @if (savedData?.publisher?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.extendedDetails.publisher.label' | translate"
      [items]="savedData.publisher"
    property="value"></div>
  }

  @if (savedData?.expires) {
    <div appPreviewRow
      [title]="'forms.educationalResource.extendedDetails.expires.label' | translate"
    [item]="savedData.expires | date: 'd.M.yyyy'"></div>
  }

  @if (prerequisites?.length > 0) {
    <div appPreviewRow
      [title]="'forms.educationalResource.extendedDetails.prerequisites.label' | translate"
      [items]="prerequisites"
    property="targetName"></div>
  }
</dl>

<hr />

@if (savedData?.isBasedOn) {
  <h3>{{ "forms.educationalResource.nav.basedOnDetails" | translate }}</h3>
  <dl class="row g-0">
    @if (savedData?.isBasedOn.externals) {
      @for (external of savedData.isBasedOn.externals; track external; let i = $index) {
        <dt class="col-sm-3">{{ i + 1 }}. materiaali</dt>
        <dd class="col-sm-9">
          <dl class="row g-0">
            <dt class="col-sm-3">
              {{ "forms.educationalResource.basedOnDetails.externals.inputs.name.label" | translate }}
            </dt>
            <dd class="col-sm-9">{{ external.name }}</dd>
            <dt class="col-sm-3">
              {{ "forms.educationalResource.basedOnDetails.externals.inputs.author.label" | translate }}
            </dt>
            <dd class="col-sm-9">
              @for (author of external.author; track author; let isLast = $last) {
                {{ author }}
                @if (!isLast) {
                  <span>,</span>
                }
              }
            </dd>
            <dt class="col-sm-3">
              {{ "forms.educationalResource.basedOnDetails.externals.inputs.link.label" | translate }}
            </dt>
            <dd class="col-sm-9">
              <a [href]="external.url" target="_blank" rel="noopener">{{ external.url }}</a>
            </dd>
          </dl>
        </dd>
      }
    }
  </dl>
  <hr />
}

<h3>{{ "forms.educationalResource.nav.licenseDetails" | translate }}</h3>

<dl class="row g-0">
  <div appPreviewRow
    [title]="'forms.educationalResource.license.title' | translate"
    [item]="savedData?.license"
    [required]="!hasLicense"
  [routerLinkOptions]="['/lisaa-oppimateriaali', 5]"></div>
</dl>

<hr />

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-group form-check">
    <input type="checkbox" class="form-check-input" id="confirm" formControlName="confirm" />
    <label class="form-check-label" for="confirm">
      {{ "forms.educationalResource.preview.confirm" | translate }}
    </label>

    <ul>
      @switch (lang) {
        @default {
          <li>kaikki tekijät ovat hyväksyneet materiaalin julkaisun avoimella lisenssillä,</li>
          <li>
            muiden tekijöiden aineistot (esim. kuvat) voidaan julkaista avoimesti joko aineistojen oman avoimen
            lisenssin tai erikseen saadun luvan perusteella,
          </li>
          <li>
            materiaalissa näkyvien henkilöiden kuvien tai muiden henkilötietojen osalta lupa julkaisuun on saatu ko.
            henkilöiltä ja
          </li>
          <li>materiaali on parhaan tietomme mukaan alan hyvien tapojen mukainen</li>
        }
        @case ('en') {
          <li>all authors have agreed to publish the OER with an open licence</li>
          <li>
            I have permission to use materials made by others that are included in my material (f.ex. pictures) through
            licence or other agreement
          </li>
          <li>I have gained permission from the relevant parties to include any personal data included in the OER</li>
          <li>the OER is according to our best knowledge made with best practices of our field</li>
        }
        @case ('sv') {
          <li>fått tillåtelse från alla upphovspersoner att publicera lärresurs med en Creative Commons licens</li>
          <li>tillåtelse att använda alla materialen i min lärresurs (till exemple bilder)</li>
          <li>
            fått tillåtelse från alla personer att publicera deras personuppgift (om jag har personuppgift i min
            lärresurs)
          </li>
          <li>gjort lärresursen, enligt vår bästa kunskap, med den bästa praxis inom vårt område</li>
        }
      }
    </ul>
  </div>

  <div class="row">
    <div class="col">
      <button type="button" class="btn btn-gray" (click)="previousTab()">
        {{ "forms.common.previous" | translate }}
      </button>
    </div>

    <div class="col-auto">
      <button type="reset" class="btn btn-cancel" (click)="abort()">{{ "forms.common.abort" | translate }}</button>
    </div>

    <div class="col-auto">
      <button type="submit" class="btn btn-blue" [disabled]="form?.invalid">
        {{ "forms.common.save" | translate }}
      </button>
    </div>
  </div>
</form>
